module.exports = {
	admin: require('./admin'),
	documents: require('./documents'),
	messages: require('./messages'),
	products: require('./products'),
	document_center: require('./document-center'),
	'quote-builder': require('./quote-builder'),
};
